import React from 'react';

import useApi from './useApi';

const BASE_URL = '/postal-code';

export const usePostalCode = () => {
  const { get } = useApi();

  const loadAddress = React.useCallback(
    async postalCode => {
      const address = await get(`${BASE_URL}/${postalCode}`);
      return address;
    },
    [get],
  );

  return { loadAddress };
};

export default usePostalCode;
